import { generateVideoUrl, parseUrl } from '@intercom/embercom-prosemirror-composer/lib/helpers/video-url-parser';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const videoSpec = {
  inline: false,
  attrs: {
    type: {
      default: 'video'
    },
    provider: {
      default: 'youtube'
    },
    id: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: 'iframe',
    getAttrs(dom) {
      let {
        provider,
        id
      } = parseUrl(dom.src);
      return {
        provider,
        id
      };
    }
  }],
  toDOM(node) {
    let src = generateVideoUrl(node.attrs.provider, node.attrs.id);
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.video}`
    }, ['iframe', {
      src,
      style: 'pointer-events: none;'
    }]];
  }
};